import { createSelector } from 'reselect'

const isOpen = state => state.WorksStore.createAssessmentDialog.opened

const getSelectedWorks = state =>
  state.WorksStore.createAssessmentDialog.selectedWorks

const getSelectedWorksCount = createSelector(
  [getSelectedWorks],
  works => works.length
)

export { isOpen, getSelectedWorks, getSelectedWorksCount }
